<div [attr.class]="(theme === 'dark' ? 'accordion-module' : null)">

  <fieldset [attr.class]="(theme === 'dark' ? 'dark' : null)">

    <legend *ngIf="accordionTitle" class="sr-only" [innerHtml]="accordionTitle"></legend>

    <h3 *ngIf="sectionMainTitle" [innerHtml]="sectionMainTitle"></h3>

    <div class="accordion menu form linear" [ngClass]="{'cbolui-right-arrow': isRightAlignedArrow}">

      <div class="row title" [ngClass]="{'hide-toggle-button': hideToggle}">

        <div class="hidden-xs hidden-sm col-xs-12 text-right">
          <button [attr.aria-expanded]="allSectionsOpen" (click)="toggleAllSections($event)"
            class="desktop toggle-accordion btn-link">
            {{allSectionsOpen ? collapseAllButtonText : expandAllButtonText}}
          </button>
        </div>

        <div class="hidden-lg hidden-md col-xs-12">
          <button [attr.aria-expanded]="allSectionsOpen" (click)="toggleAllSections($event)"
            class="mobile toggle-accordion btn-link">
            {{allSectionsOpen ? collapseAllButtonText : expandAllButtonText}}
          </button>
        </div>

      </div>

      <div class="row">
        <div aria-hidden="true" class="col-md-6" *ngIf="accordionTitle" role="presentation"
          [innerHtml]="accordionTitle"></div>
      </div>

      <div class="title">
        <ul class="mainnav {{!theme || theme !== 'dark' ? 'theme-light' : null}}">
          <ng-content></ng-content>
        </ul>
      </div>

    </div>
  </fieldset>
</div>
